var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="CDB-Widget-header js-header">\n  <div class="js-title"></div>\n  ';
 if (!isCollapsed) { ;
__p += '\n    ';
 if (showSource) { ;
__p += '\n      <dl class="CDB-Widget-info u-tSpace">\n        <div class="u-ellipsis u-flex">\n          <span class="CDB-SelectorLayer-letter CDB-Text CDB-Size-small u-whiteTextColor u-rSpace u-upperCase" style="background-color: ' +
((__t = ( sourceColor )) == null ? '' : __t) +
';">' +
((__t = ( sourceId )) == null ? '' : __t) +
'</span>\n          <p class="CDB-Text CDB-Size-small u-mainTextColor u-ellipsis u-flex">\n            ' +
((__t = ( sourceType )) == null ? '' : __t) +
' <span class="u-altTextColor u-lSpace u-ellipsis" title="' +
((__t = ( layerName )) == null ? '' : __t) +
'">' +
((__t = ( layerName )) == null ? '' : __t) +
'</span>\n          </p>\n        </div>\n      </dl>\n    ';
 } ;
__p += '\n    ';
 if (showStats) { ;
__p += '\n      <dl class="CDB-Widget-info CDB-Text CDB-Size-small u-secondaryTextColor u-upperCase u-tSpace">\n        ';
 if (showNulls) { ;
__p += '\n        <dt class="CDB-Widget-infoCount js-nulls">0</dt><dd class="CDB-Widget-infoDescription">NULL ROWS</dd>\n        ';
 } ;
__p += '\n        <dt class="CDB-Widget-infoCount js-min">0</dt><dd class="CDB-Widget-infoDescription">MIN</dd>\n        <dt class="CDB-Widget-infoCount js-avg">0</dt><dd class="CDB-Widget-infoDescription">AVG</dd>\n        <dt class="CDB-Widget-infoCount js-max">0</dt><dd class="CDB-Widget-infoDescription">MAX</dd>\n      </dl>\n    ';
 } ;
__p += '\n  ';
 } ;
__p += '\n</div>\n';
 if (!isCollapsed) { ;
__p += '\n<div class="CDB-Widget-content CDB-Widget-content--histogram js-content">\n  <div class="CDB-Widget-filter CDB-Widget-contentSpaced ">\n    <p class="CDB-Text CDB-Size-small is-semibold u-upperCase js-val">…</p>\n    <div class="CDB-Widget-filterButtons js-filter is-hidden">\n      <button class="CDB-Text CDB-Size-small u-upperCase u-actionTextColor CDB-Widget-filterButton js-zoom">zoom</button>\n      <button class="CDB-Text CDB-Size-small u-upperCase u-actionTextColor CDB-Widget-filterButton js-clear">clear</button>\n    </div>\n  </div>\n  <div class="js-mini-chart"></div>\n  <div class="CDB-Chart--histogram js-chart"></div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb-deep-insights.js/src/widgets/histogram/content.tpl
// module id = 898
// module chunks = 2 3